/*
const translations = {
  IT: {
    ATTIVITA_DSM: "ATTIVITÀ DSM",
    CONGRESSI: "Congressi e workshop",
    BANDI: "Bandi e premi",
    ANNUNCI: "Annunci DSM",
    EVENTI: "Eventi con supporto DSM",

    FORMAZIONE: "FORMAZIONE",
    SCUOLE: "Scuole e corsi",
    SCUOLE_PRATICHE: "Scuole di formazione <br>pratico-applicative",

    SPAZIO_GIOVANI: "SPAZIO GIOVANI",
    BACHECA: "Bacheca",

    DSM: "DSM",
    ARCHIVIO: "Archivio DSM",
    VIRTUALE: "DSM virtuale",
    AGENDA: "Agenda DSM",
    ISCRIVERSI: "Iscriversi",

    SPONSOR: "SPONSOR",
    SPONSOR_LINK: "Sponsor",
  },
  EN: {
    ATTIVITA_DSM: "DSM ACTIVITIES",
    CONGRESSI: "Conferences and workshops",
    BANDI: "Calls and awards",
    ANNUNCI: "DSM announcements",
    EVENTI: "Events with DSM support",

    FORMAZIONE: "TRAINING",
    SCUOLE: "Schools and courses",
    SCUOLE_PRATICHE: "Practical training schools",

    SPAZIO_GIOVANI: "YOUTH SPACE",
    BACHECA: "Bulletin board",

    DSM: "DSM",
    ARCHIVIO: "DSM Archive",
    VIRTUALE: "Virtual DSM",
    AGENDA: "DSM diary",
    ISCRIVERSI: "Register",

    SPONSOR: "SPONSORS",
    SPONSOR_LINK: "Sponsors",
  },
  ES: {
    ATTIVITA_DSM: "ACTIVIDADES DSM",
    CONGRESSI: "Congresos y talleres",
    BANDI: "Convocatorias y premios",
    ANNUNCI: "Anuncios DSM",
    EVENTI: "Eventos con apoyo DSM",

    FORMAZIONE: "FORMACIÓN",
    SCUOLE: "Escuelas y cursos",
    SCUOLE_PRATICHE: "Escuelas de formación <br>práctica-aplicada",

    SPAZIO_GIOVANI: "ESPACIO JÓVENES",
    BACHECA: "Tablón de anuncios",

    DSM: "DSM",
    ARCHIVIO: "Archivo DSM",
    VIRTUALE: "DSM virtual",
    AGENDA: "Agenda DSM",
    ISCRIVERSI: "Inscribirse",

    SPONSOR: "PATROCINADORES",
    SPONSOR_LINK: "Patrocinadores",
  },
};

export default translations;
*/
























const translations = {
  IT: {
    ATTIVITA_DSM: "ATTIVITÀ DSM",
    CONGRESSI: "Congressi e workshop",
    BANDI: "Bandi e premi",
    ANNUNCI: "Annunci DSM",
    EVENTI: "Eventi con supporto DSM",

    FORMAZIONE: "FORMAZIONE",
    SCUOLE: "Scuole e corsi",
    SCUOLE_PRATICHE: "Scuole di formazione <br>pratico-applicative",

    SPAZIO_GIOVANI: "SPAZIO GIOVANI",
    BACHECA: "Bacheca",

    DSM: "DSM",
    ARCHIVIO: "Archivio DSM",
    VIRTUALE: "DSM virtuale",
    AGENDA: "Agenda DSM",
    ISCRIVERSI: "Iscriversi",

    SPONSOR: "SPONSOR",
    SPONSOR_LINK: "Sponsor",

    // Nuove voci
    CONSIGLIO_DIRETTIVO: "CONSIGLIO DIRETTIVO",
    LINEE_PROGRAMMATICHE: "LINEE PROGRAMMATICHE",
    REGOLAMENTO: "REGOLAMENTO",
    STORIA_DSM: "STORIA DSM",
    IN_RICORDO_DI: "IN RICORDO DI",
    CONTATTI: "CONTATTI",
    ALTRE_SOCIETA: "ALTRE SOCIETÀ",
    FEEDBACK: "FEEDBACK",
  },
  EN: {
    ATTIVITA_DSM: "DSM ACTIVITIES",
    CONGRESSI: "Conferences and workshops",
    BANDI: "Calls and awards",
    ANNUNCI: "DSM announcements",
    EVENTI: "Events with DSM support",

    FORMAZIONE: "TRAINING",
    SCUOLE: "Schools and courses",
    SCUOLE_PRATICHE: "Practical training schools",

    SPAZIO_GIOVANI: "YOUTH SPACE",
    BACHECA: "Bulletin board",

    DSM: "DSM",
    ARCHIVIO: "DSM Archive",
    VIRTUALE: "Virtual DSM",
    AGENDA: "DSM diary",
    ISCRIVERSI: "Register",

    SPONSOR: "SPONSORS",
    SPONSOR_LINK: "Sponsors",

    // Nuove voci
    CONSIGLIO_DIRETTIVO: "BOARD OF DIRECTORS",
    LINEE_PROGRAMMATICHE: "PROGRAMMATIC GUIDELINES",
    REGOLAMENTO: "REGULATIONS",
    STORIA_DSM: "DSM HISTORY",
    IN_RICORDO_DI: "IN MEMORY OF",
    CONTATTI: "CONTACTS",
    ALTRE_SOCIETA: "OTHER SOCIETIES",
    FEEDBACK: "FEEDBACK",
  },
  ES: {
    ATTIVITA_DSM: "ACTIVIDADES DSM",
    CONGRESSI: "Congresos y talleres",
    BANDI: "Convocatorias y premios",
    ANNUNCI: "Anuncios DSM",
    EVENTI: "Eventos con apoyo DSM",

    FORMAZIONE: "FORMACIÓN",
    SCUOLE: "Escuelas y cursos",
    SCUOLE_PRATICHE: "Escuelas de formación <br>práctica-aplicada",

    SPAZIO_GIOVANI: "ESPACIO JÓVENES",
    BACHECA: "Tablón de anuncios",

    DSM: "DSM",
    ARCHIVIO: "Archivo DSM",
    VIRTUALE: "DSM virtual",
    AGENDA: "Agenda DSM",
    ISCRIVERSI: "Inscribirse",

    SPONSOR: "PATROCINADORES",
    SPONSOR_LINK: "Patrocinadores",

    // Nuevas entradas
    CONSIGLIO_DIRETTIVO: "CONSEJO DIRECTIVO",
    LINEE_PROGRAMMATICHE: "LINEAMIENTOS PROGRAMÁTICOS",
    REGOLAMENTO: "REGLAMENTO",
    STORIA_DSM: "HISTORIA DEL DSM",
    IN_RICORDO_DI: "EN MEMORIA DE",
    CONTATTI: "CONTACTO",
    ALTRE_SOCIETA: "OTRAS SOCIEDADES",
    FEEDBACK: "RETROALIMENTACIÓN",
  },
};

export default translations;
